import { useQuery } from "@tanstack/react-query";
import type { User } from "@workspace/db";

export const AUTH_QUERY_KEY = ["/api/auth/user"] as const;

export async function fetchCurrentUser(): Promise<User | null> {
  const res = await fetch("/api/auth/user", { credentials: "include" });
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(`Auth check failed: ${res.status}`);
  return res.json();
}

export function useAuth({ enabled = true }: { enabled?: boolean } = {}) {
  const isLoginRoute =
    typeof window !== "undefined" && window.location.pathname === "/login";
  const { data: user, isLoading, refetch } = useQuery<User | null>({
    queryKey: AUTH_QUERY_KEY,
    queryFn: fetchCurrentUser,
    enabled: enabled && !isLoginRoute,
    retry: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    user: user ?? undefined,
    isLoading,
    isAuthenticated: !!user,
    refresh: refetch,
  };
}
